import { useState } from "react";
import { cn } from "@/lib/utils";

interface GifMessageRendererProps {
  gifUrl: string;
  isCurrentUser: boolean;
}

export function GifMessageRenderer({
  gifUrl,
  isCurrentUser,
}: GifMessageRendererProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <div
        className={cn(
          "inline-block rounded-3xl px-4 py-2",
          isCurrentUser ? "bg-blue-600 text-white" : "bg-zinc-100 text-black",
        )}
      >
        <span className="text-sm">Failed to load GIF</span>
      </div>
    );
  }

  return (
    <div className="relative">
      {isLoading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-gray-100">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600" />
        </div>
      )}
      <img
        src={gifUrl}
        alt="GIF"
        className="max-h-[200px] max-w-[250px] rounded-lg object-cover"
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setIsLoading(false);
          setHasError(true);
        }}
      />
    </div>
  );
}
